import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import InstagramWarning from "../components/InstagramWarning";

function ReferralProgramConditions_en() {
    return (
        <div className={StaticPageStyles.staticPageContainer}>
            <InstagramWarning/>
            <h1>LeelaOnline.net Referral Program Terms</h1>
            <h3>1. Introduction</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>This referral program allows registered users to earn rewards for referring new users to LeelaOnline.
                        By using a unique referral link, you can invite friends, acquaintances, and other users and earn rewards from their payments.</li>
                </ul>
            </p>

            <h3>2. Program Participants</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>The referral program is available only to registered users of our website. Participation in the program is voluntary and free of charge.</li>
                </ul>
            </p>

            <h3>3. Unique Referral Link</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Each participant in the program receives a unique referral link, which can be found in their personal account.
                        This link can be shared with others to invite them to the site.</li>
                </ul>
            </p>

            <h3>4. Rewards</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>The reward is a percentage of the payments made by new users who registered using your referral link.
                        The reward percentage is determined individually and may be changed at the discretion of the site administration.</li>
                </ul>
            </p>

            <h3>5. Conditions for Receiving Rewards</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>The new user must register on our site using your unique referral link.</li>
                    <li className={StaticPageStyles.staticPageText}>The new user must make a payment on the site.</li>
                    <li className={StaticPageStyles.staticPageText}>Rewards will only be credited for payments made after registration via the referral link.</li>
                </ul>
            </p>

            <h3>6. Reward Payment</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>The reward is credited to your internal account on the site.</li>
                    <li className={StaticPageStyles.staticPageText}>You can request a reward payout once the amount in your account reaches the minimum threshold set by the site administration.</li>
                    <li className={StaticPageStyles.staticPageText}>You can use the credited reward to pay for services on LeelaOnline.</li>
                    <li className={StaticPageStyles.staticPageText}>The reward will only be credited for payments made after registration via the referral link.</li>
                    <li className={StaticPageStyles.staticPageText}>The payout can be made to your bank account, electronic wallet, or another method agreed upon with the site administration.</li>
                </ul>
            </p>

            <h3>7. Changes to Referral Program Terms</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>We reserve the right to change the terms of the referral program at any time without prior notice. Your continued use of the referral program after changes have been made means you agree to the new terms.</li>
                </ul>
            </p>

            <h3>8. Abuse and Fraud</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Any attempts to abuse or commit fraud using the referral program will result in the participant's disqualification, cancellation of all credited rewards, and possible account suspension.</li>
                </ul>
            </p>

            <h3>9. Contact Information</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>If you have any questions or comments regarding this referral program, please contact us via email at support@leelaonline.net.</li>
                </ul>
            </p>
        </div>
    )
}

export default ReferralProgramConditions_en